<template>
  <div class="country__wrapper" :class="{ 'not-subscribe': notSubscribe }">
    <component
      :is="link ? 'nuxt-link' : 'div'"
      :to="link"
      class="country"
      :class="{ state: isState, 'not-active': notActive }"
    >
      <div class="country__icon">
        <img v-if="flag_url" :src="flag_url" alt="" />
        <img
          v-else-if="iso"
          :src="require(`../../assets/images/flags/${iso.toLowerCase()}.svg`)"
          alt=""
        />
        <svg v-else class="country__icon">
          <circle opacity="50%" cx="50%" cy="50%" r="50%" fill="red" />
        </svg>
      </div>
      <span>
        <h3>{{ jurisdiction }}</h3>
        <strong>{{ title }}</strong>
        <p><Date :text="date" /></p>
      </span>
    </component>
    <Tooltip v-if="notSubscribe" :size="'small'" />
  </div>
</template>

<script>
import { mapState } from "vuex";
// import config from "../../nuxt.config";

export default {
  name: "RecentUpdate",
  components: {
    Tooltip: () => import("../elements/Tooltip"),
    Date: () => import("../elements/Date"),
  },
  props: {
    isState: {
      type: Boolean,
      default: false,
    },
    notActive: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    // eslint-disable-next-line vue/prop-name-casing
    flag_url: {
      type: String,
      default: null,
    },
    iso: {
      type: String,
      default: null,
    },
    access: {
      type: [Array, Number],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    jurisdiction: {
      type: String,
      default: null,
    },
    date: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      notSubscribe: false,
    };
  },
  computed: {
    ...mapState("Profile", ["userAccess"]),
  },
  mounted() {
    if (!this.access || !this.access.length) {
      this.notSubscribe = false;
    } else {
      for (let i = 0; i < this.access.length; i++) {
        if (this.userAccess && this.userAccess.includes(this.access[i])) {
          this.notSubscribe = false;
          if (this.productAccess && this.productAccess[i]) {
            break;
          }
        } else {
          this.notSubscribe = true;
        }
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.country {
  display: flex;
  align-items: top;
  color: $text_gray;
  font-size: 1.6rem;
  text-decoration: none;
  transition: 0.3s ease-out;

  &__wrapper {
    position: relative;
    width: 100%;
    // &.recentupdate {
    //   &__title {
    //     font-weight: bold;
    //   }
    // }
  }

  &:hover {
    color: $brightGreen;
  }

  &__icon {
    width: 3rem;
    height: 3rem;
    overflow: hidden;
    margin-right: 1.5rem;

    img {
      width: 100%;
    }
  }

  span {
    width: calc(100% - 4.6rem);

    h3 {
      font-size: 1.4rem;
    }

    strong {
      font-size: 1.8rem;
    }
  }

  &.state {
    font-size: 1.4rem;

    .country__icon {
      width: 4rem;
      height: 2rem;
    }

    span {
      width: calc(100% - 3.6rem);
    }
  }

  &.not-active {
    opacity: 0.7;

    &:hover {
      color: $text_gray;
    }
  }
}
</style>
